import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Ledger" }

import {searchFormConfig} from '@/views/main/report/ledger/config/search.config'
import {contentTableConfig} from '@/views/main/report/ledger/config/content.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {useRouter} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'Ledger',
  setup(__props) {

const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()

const router = useRouter()
const handleRecordLedger = (item: any) => {
  router.push({
    path: '/main/report/ledger/recordLedger',
    query: {
      ...item
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "ledger",
      deleteTip: "确认删除台账记录吗？",
      onNewBtnClick: handleRecordLedger,
      onEditBtnClick: handleRecordLedger
    }, null, 8, ["contentTableConfig"])
  ]))
}
}

})